export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.27-1313.03",
  commitId: "1455c486edcb8c1b3db171be6f66d4c6d86e3c25",
  commitTime: "2026-04-27T13:13:03.000Z",
});
